import { recommendations } from "@/mocks/loveHelperData";

export default function RecommendSection() {
  return (
    <section id="recommend" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-semibold text-primary-600">热门内容</span>
            <h2 className="mt-2 text-2xl font-bold text-foreground-900 md:text-4xl">
              粉丝都在看
            </h2>
          </div>
          <a
            href="#guide"
            className="whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            更多内容 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {recommendations.map((r) => (
            <a
              key={r.id}
              href="#guide"
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative h-44 w-full overflow-hidden bg-background-200">
                <img
                  src={r.image}
                  alt={`${r.title} 恋爱辅助器漫画解析`}
                  title={`${r.title} - 恋爱辅助器漫画`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs text-foreground-600">
                  <i className="ri-time-line"></i> {r.time}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 md:text-base">{r.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{r.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}